import { defineStore } from 'pinia'
import { ref } from 'vue'
import { jwtDecode } from 'jwt-decode'
import { renewTokenCase } from '../../domain/usecases/renewTokenUsecase'
import { logoutCase } from '../../domain/usecases/LogoutUseCase'

export const useAuthenticationStore = defineStore('authenticationStore', () => {
  const authenticationData = ref<{
    accessToken?: string
    refreshToken?: string
  }>({
    accessToken: undefined,
    refreshToken: undefined
  })

  function setAuthenticationData() {
    authenticationData.value.accessToken = localStorage.getItem('accessToken') ?? undefined
    authenticationData.value.refreshToken = localStorage.getItem('refreshToken') ?? undefined
  }

  async function checkTokenExpiration() {
    if (!authenticationData.value.accessToken) return
    const decodedAccessToken = jwtDecode(authenticationData.value.accessToken)

    if (!decodedAccessToken) return
    if (new Date(decodedAccessToken.exp! * 1000) < new Date()) {
      try {
        const tokenResponse = await renewTokenCase()
        if (!tokenResponse) logout()
      } catch (error) {
        logout()
      }
    }
  }

  async function logout() {
    await logoutCase()
    authenticationData.value = {
      accessToken: undefined,
      refreshToken: undefined
    }
  }

  return {
    authenticationData,
    setAuthenticationData,
    checkTokenExpiration,
    logout
  }
})
